import { StakingWidget } from "./widget";
import './style/index.css'
import './style/index.tailwind.css'

export default StakingWidget